
angular.module('substoreApp')

    .service('partnerFeatureWeb2t', [ '$log', function ($log) {

        var blackList2 = {
            "01": true,
            "32": true
        };

        var blackList3 = {
            "310": true,
            "311": true,
            "32": true,
            "500": true,
            "501": true,
            "601": true,
            "700": true,
            "701": true,
            "800": true,
            "801": true,
            "900": true,
            "901": true,
            "902": true,
            "903": true,
            "904": true,
            "905": true
        };

        function formatFixedLineNumber(value) {
            if (!value)
                return value;

            value = value.replace(/ /g, "");

            if (value.match(/^\+49/))
                return value;

            if (value.match(/^49/))
                return "+49".concat(value.substr(2));

            if (value.match(/^0049/))
                return "+49".concat(value.substr(4));

            if (value.match(/^0/))
                return "+49".concat(value.substr(1));

            return "+49".concat(value);
        }

        function hasValidFormat(value) {
            if (!value)
                return false;

            if (!value.match(/^\+49[2-9][0-9]{1,16}$/))
                return false;

            if (blackList2.hasOwnProperty(value.substr(3, 2)))
                return false;

            if (blackList3.hasOwnProperty(value.substr(3, 3)))
                return false;

            return true;
        }

        function prepareProductDetails(scope) {
            var product = scope.data.product;
            if (product.bookingAllowed && product.reservedInstances > 0)
                product.overrideOrderButtonText = 'product_order_in_progress';
        }

        function validateFixedLineNumber(scope) {
            var fixedLineNumber = formatFixedLineNumber(scope.confirmation.requestedParameterValue);
            var isValid = hasValidFormat(fixedLineNumber);
            //$log.debug("fixedLineNumber: " + fixedLineNumber + " ==> " + isValid);
            if (isValid)
                scope.confirmation.requestedParameterValue = fixedLineNumber;
            else
                scope.confirmation.faultStates = {
                    fixedLineNumber: [ "orderselection_msg_fixedlinenumber_invalid" ]
                };

            return isValid;
        }

        function validateFixedLineNumberForOrderAdministration(scope) {
            var isValid = validateFixedLineNumber(scope);

            if (isValid)
                if (scope.confirmation.requestedParameterValue == scope.data.currentParameterValue) {
                    isValid = false;

                    scope.confirmation.faultStates = {
                        fixedLineNumber: ["orderselection_msg_fixedlinenumber_is_current"]
                    };
                }

            return isValid;
        }

        return {
            templates: {
                orderselection: { option: "partner/web2t/templates/orderselectionoption.html" },
                orderadministrationselection: { option: "partner/web2t/templates/orderselectionoption.html" }
            },
            actions: {
                productdetails: { dialog: prepareProductDetails },
                orderselection: { validation: validateFixedLineNumber },
                orderadministrationselection: { validation: validateFixedLineNumberForOrderAdministration }
            }
        };
    }]);